import { useContext, useEffect } from 'react'
import { LoadingWrapperContext } from 'src/modules/core/context'
import { ConfigurationStepProvider, PaginationProvider } from 'src/modules/core/providers'
import { EventsProvider } from 'src/modules/event/providers'
import { BookingOnboardingWrapper } from 'src/modules/user/containers/booking-onboarding-wrapper'
import { ApiService } from 'src/services/api.service'

export function BookingOnboarding() {
  const { disableLoading } = useContext(LoadingWrapperContext)

  useEffect(() => {
    disableLoading()
  }, [disableLoading])

  useEffect(() => {
    ApiService.Analytics.track('Booking_addon_onboarding_start')
  }, [])

  return (
    <ConfigurationStepProvider>
      <PaginationProvider>
        <EventsProvider>
          <BookingOnboardingWrapper />
        </EventsProvider>
      </PaginationProvider>
    </ConfigurationStepProvider>
  )
}
